const INITIAL_STATE = {
  productBranchesList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_PRODUCT_BRANCHES': {
      return { ...state, productBranchesList: action.productBranchesList };
    }
    default:
      return state;
  }
};
